var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.1389 17.8076L5.12927 12.8076M5.12927 12.8076C6.04975 12.8058 6.7945 12.0582 6.79273 11.1377C6.79096 10.2172 6.04333 9.47246 5.12286 9.47424C4.20238 9.47601 3.45763 10.2236 3.4594 11.1441C3.46117 12.0646 4.2088 12.8093 5.12927 12.8076ZM5.11644 6.14091L5.11002 2.80758M10.9722 17.7963L10.9626 12.7963M10.9498 6.12968L10.9433 2.79635M10.9498 6.12968C10.0293 6.13145 9.28454 6.87908 9.28631 7.79955C9.28808 8.72003 10.0357 9.46478 10.9562 9.46301C11.8767 9.46124 12.6214 8.71361 12.6196 7.79314C12.6179 6.87266 11.8702 6.12791 10.9498 6.12968ZM16.8055 17.7851L16.7991 14.4518M16.7991 14.4518C17.7196 14.45 18.4644 13.7024 18.4626 12.7819C18.4608 11.8614 17.7132 11.1167 16.7927 11.1184C15.8722 11.1202 15.1275 11.8678 15.1293 12.7883C15.131 13.7088 15.8787 14.4535 16.7991 14.4518ZM16.7863 7.78511L16.7767 2.78512",
    stroke: "#FCFCFD",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlider);
export default __webpack_public_path__ + "static/media/slider.0239f8535e5a1489870c8791f20b1bec.svg";
export { ForwardRef as ReactComponent };